import React from 'react'
import { createRoot } from 'react-dom/client'
import RebuyBundle from "./RebuyBundle.jsx"
// import { Provider } from 'react-redux'

document.addEventListener('DOMContentLoaded', () => {
  const bundles = document.querySelectorAll('[data-section-type="rebuy-custom-bundle"]')
  bundles.forEach((bundle) => {
    const bundleProps = JSON.parse(bundle.getAttribute('props'))
    const bundleRoot = createRoot(bundle)
    bundleRoot.render(<RebuyBundle props={bundleProps} />)
  })
})